import ApolloClientHexaService from 'ApolloClientHexaService';
import {
  CREATE_ROLE,
  DELETE_ROLE,
  GET_ROLES,
  UPDATE_ROLE,
} from 'gql/roles';

export const getRoles = async () => {
  try {
    const { data } = await ApolloClientHexaService.query({
      query: GET_ROLES,
      fetchPolicy: 'no-cache',
    });
    return { success: true, error: false, data: data?.getRoles || [] };
  } catch (error) {
    return { success: false, error: { ...error }, data: [] };
  }
};

export const createRole = async (input) => {
  try {
    const { data } = await ApolloClientHexaService.mutate({
      mutation: CREATE_ROLE,
      variables: { input },
    });
    return { success: true, error: false, data: data?.createRole || null };
  } catch (error) {
    return { success: false, error: { ...error }, data: null };
  }
};

export const updateRole = async (input) => {
  try {
    const { data } = await ApolloClientHexaService.mutate({
      mutation: UPDATE_ROLE,
      variables: { input },
    });
    return { success: true, error: false, data: data?.updateRole || null };
  } catch (error) {
    return { success: false, error: { ...error }, data: null };
  }
};

export const deleteRole = async (code) => {
  try {
    const { data } = await ApolloClientHexaService.mutate({
      mutation: DELETE_ROLE,
      variables: { code },
    });
    return { success: true, error: false, data: !!data?.deleteRole };
  } catch (error) {
    return { success: false, error: { ...error }, data: false };
  }
};
